import SvgImage from '@components/svg'
import { TableHeaderProps } from './interface'
import {
  StyleNotFoundWrapper,
  StyleTableBody,
  StyleTableBodyText,
  StyleTableRow,
} from './style'
interface TableDataProps {
  items?: any[]
  columns?: TableHeaderProps[]
  tbodyBackground?: string
  onClickRow?: (item: any, event: any) => void
  hasBorderBottom?: boolean
}
const TableData = ({
  items = [],
  columns = [],
  tbodyBackground,
  onClickRow,
  hasBorderBottom = true,
}: TableDataProps) => {
  return (
    <StyleTableBody tbodyBackground={tbodyBackground}>
      {!!items?.length ? (
        <>
          {items?.map((item: any, index: number) => (
            <StyleTableRow
              borderBottom={hasBorderBottom}
              key={index}
              onClick={(e: any) => {
                onClickRow && onClickRow(item, e)
              }}
            >
              {columns?.map((column: any, i: number) => (
                <StyleTableBodyText key={i + 5}>
                  {column.render
                    ? column.render(item, index + 1 || 1)
                    : item[column.key]
                      ? item[column.key]
                      : '-'}
                </StyleTableBodyText>
              ))}
            </StyleTableRow>
          ))}
        </>
      ) : (
        <StyleTableRow>
          <StyleTableBodyText
            colSpan={columns.length}
            style={{
              fontSize: 24,
              padding: '60px 0px',
              color: '#ddd',
              textAlign: 'center',
            }}
          >
            <StyleNotFoundWrapper>
              <SvgImage src={'empty'} width={100} height={150} />
              <p style={{ marginTop: -20 }}> No data found</p>
            </StyleNotFoundWrapper>
          </StyleTableBodyText>
        </StyleTableRow>
      )}
    </StyleTableBody>
  )
}

export default TableData
